var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReceiptText = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#6E7481",
  d: "m12.566 15.45-1.683 1.683a1.25 1.25 0 0 1-1.767 0l-1.682-1.682a1.25 1.25 0 0 0-1.635-.116l-1.132.85a.833.833 0 0 1-1.333-.667V5q0-2.5 2.5-2.5h8.333q2.5 0 2.5 2.5v10.518a.833.833 0 0 1-1.334.666l-1.132-.849a1.25 1.25 0 0 0-1.635.116",
  opacity: 0.4
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#6E7481",
  d: "M13.333 8.125H6.667a.625.625 0 0 1 0-1.25h6.666a.625.625 0 0 1 0 1.25m-1.875 2.708a.625.625 0 0 0-.625-.625H6.667a.625.625 0 0 0 0 1.25h4.166c.345 0 .625-.28.625-.625"
})));
export default SvgReceiptText;